// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"276":"262ae409","283":"1bb46756","357":"ce07fb2f","742":"83021a16","762":"36aeab42","808":"1ffd5daa","832":"6577ef27","927":"c5345d69","943":"fa420d45"}[chunkId] + ".chunk.css";
};